import { render, staticRenderFns } from "./PreView.vue?vue&type=template&id=dcb18d9a&"
import script from "./PreView.vue?vue&type=script&lang=js&"
export * from "./PreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports